export default "__VITE_ASSET__C1GgIAqT__"